import React from "react"
import Layout from "../components/layout"
import Hero from "../components/hero"

export default () => (
  <Layout>
    <Hero center hero="Support" herosub="Support page here" />
  </Layout>
)
